import React, { Fragment, useEffect, useState } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
// import { softskillBlocksExport, hardskillBlocksExport } from '../../components/skillsBlocks'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../context/auth/useAuth'
import { getCandidates } from '../../actions/candidatesActions'
import { getSchools } from '../../actions/schoolsActions'
// import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
// import { Link } from 'react-router-dom'
import { getProfileTypes } from '../../actions/profileTypesActions'
import Swal from 'sweetalert2'

export default function Dashboard() {
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()

	// const {candidates} = useSelector(state=>state.candidates)
	// const {schools} = useSelector(state=>state.schools)
	// const {profileTypes, resultprofileType} = useSelector(state=>state.profileTypes)
	const {resultprofileType} = useSelector(state=>state.profileTypes)

	const [skillaux, setSkillaux] = useState(null)
	// const softskillBlocks = softskillBlocksExport
	// const hardskillBlocks = hardskillBlocksExport

    // const [typeSoftskill, setTypeSoftskill] = useState('interpersonal')
    // const [typeHardskill, setTypeHardskill] = useState('interpersonal')
    // const [newSkills, setNewSkills] = useState({
	// 	softskills: {
	// 		interpersonal: [],
	// 		social: [],
	// 		methodical: [],
	// 		languages: [],
	// 		technological: []
	// 	},
	// 	hardskills: {
	// 		interpersonal: [],
	// 		social: [],
	// 		methodical: [],
	// 		languages: [],
	// 		technological: []
	// 	}
	// })

	useEffect(() => {
		if(client){
			dispatch(getProfileTypes())
			dispatch(getCandidates())
			dispatch(getSchools())
		}
	},[dispatch, t, client])

	// const columnsCandidates = [
	// 	{
	// 		name: t('admin.dashboard.name'),
	// 		cell: candidate =>
	// 			<>
	// 				<div className='text-center'>
	// 					{candidate.image
	// 						?
	// 							<img className="img-profile-small me-3" alt="Preview" src={typeof candidate.image === 'string' ? candidate.image : URL.createObjectURL(candidate.image)} />
	// 						:
	// 							<i className="fas fa-user fa-2x img-profile-small me-3"></i>
	// 					}
	// 				</div>
	// 				<div className='text-left'>
	// 					{candidate.firstname} {candidate.lastname}
	// 				</div>
	// 			</>,
	// 		selector: (school) => school.name,
	// 		sortable: true,
	// 	},{
	// 		name: t('admin.dashboard.name'),
	// 		cell: candidate =>
	// 			<div>
	// 				{candidate.firstname} {candidate.lastname}
	// 			</div>,
	// 		selector: (candidate) => candidate.firstname,
	// 		sortable: true,
	// 	},{
	// 		name: t('admin.dashboard.availability'),
	// 		cell: candidate =>
	// 			<div>
    //                 {candidate.searching
	// 					?
	// 						<i className="fa fa-thumbs-up text-success" aria-hidden="true"></i>
	// 					:
	// 						<i className="fa fa-thumbs-down text-danger" aria-hidden="true"></i>
	// 				}
	// 			</div>,
	// 		selector: (candidate) => candidate.searching,
	// 		sortable: true,
	// 	},{
	// 		name: t('admin.dashboard.marketing'),
	// 		cell: candidate =>
	// 			<div>
	// 				{candidate.marketing
	// 					?
	// 						<i className="fa fa-thumbs-up text-success" aria-hidden="true"></i>
	// 					:
	// 						<i className="fa fa-thumbs-down text-danger" aria-hidden="true"></i>
	// 				}
	// 			</div>,
	// 		selector: (candidate) => candidate.marketing,
	// 		sortable: true,
	// 	},{
	// 		name: '',
	// 		cell: candidate =>
	// 			<div>
	// 				<Link to={`/admin/candidateprofile/${candidate.iduser}`}>
	// 					{t('admin.dashboard.checkprofile')}
	// 				</Link>
	// 			</div>,
	// 		selector: (candidate) => candidate.marketing,
	// 		sortable: true,
	// 	}
	// ]

	// const columnsSchools = [
	// 	{
	// 		name: t('admin.dashboard.name'),
	// 		cell: school =>
	// 			<>
	// 				<div className='text-center'>
	// 					{school.image
	// 						?
	// 							<img className="img-profile-small me-3" alt="Preview" src={typeof school.image === 'string' ? school.image : URL.createObjectURL(school.image)} />
	// 						:
	// 							<i className="fas fa-user fa-2x img-profile-small me-3"></i>
	// 					}
	// 				</div>
	// 				<div className='text-left'>
	// 					{school.name} ({school.code})
	// 				</div>
	// 			</>,
	// 		selector: (school) => school.name,
	// 		sortable: true,
	// 	},{
	// 		name: t('admin.dashboard.marketing'),
	// 		cell: school =>
	// 			<div>
	// 				{school.marketing
	// 					?
	// 						<i className="fa fa-thumbs-up text-success" aria-hidden="true"></i>
	// 					:
	// 						<i className="fa fa-thumbs-down text-danger" aria-hidden="true"></i>
	// 				}
	// 			</div>,
	// 		selector: (school) => school.marketing,
	// 		sortable: true,
	// 	},{
	// 		name: '',
	// 		cell: school =>
	// 			<div>
	// 				<Link to={`/admin/schoolprofile/${school.iduser}`}>
	// 					{t('admin.dashboard.checkprofile')}
	// 				</Link>
	// 			</div>,
	// 		selector: (school) => school.marketing,
	// 		sortable: true,
	// 	}
	// ]

	// const columnsProfileTypes = [
	// 	{
	// 		name: t('admin.dashboard.profiletype'),
	// 		cell: profiletype =>
	// 			<>
	// 				<div className='text-left'>
	// 					{profiletype.name}
	// 				</div>
	// 			</>,
	// 		selector: (profiletype) => profiletype.name,
	// 		sortable: true,
	// 	},{
	// 		name: t('admin.dashboard.skills'),
	// 		cell: profiletype =>
	// 			<Row className='text-start'>
	// 				<Col>
	// 					{t('admin.dashboard.softskills')}<br/>
	// 					{softskillBlocks?.map((skillblock, index) => (
	// 						<div key={index} className='my-3'>
	// 							{profiletype?.softskills?.[skillblock]?.length > 0
	// 								?
	// 									<>- {t('admin.dashboard.'+skillblock)}</>
	// 								:
	// 									<></>
	// 							}
	// 							{profiletype?.softskills?.[skillblock]?.length > 0
	// 								?
	// 									profiletype?.softskills?.[skillblock]?.map((skill, key) => (
	// 										<div key={key} id={`softskill-`+skillblock+`-`+key} className='text-start'>
	// 											<i className="fas fa-times fa-xs" onClick={e => handleRemoveSkill(e, 'softskill', skillblock, key, profiletype._id)}></i> {skill}
	// 										</div>
	// 									))
	// 								:
	// 									<></>
	// 							}
	// 						</div>
	// 					))}
	// 				</Col>
	// 				<Col>
	// 					{t('admin.dashboard.hardskills')}
	// 					{hardskillBlocks?.map((skillblock, index) => (
	// 						<div key={index} className='my-3'>
	// 							{profiletype?.hardskills?.[skillblock]?.length > 0
	// 								?
	// 									<>- {t('admin.dashboard.'+skillblock)}</>
	// 								:
	// 									<></>
	// 							}
	// 							{profiletype?.hardskills?.[skillblock]?.length > 0
	// 								?
	// 									profiletype?.hardskills?.[skillblock]?.map((skill, key) => (
	// 										<div key={key} id={`hardskill-`+skillblock+`-`+key} className='text-start'>
	// 											<i className="fas fa-times fa-xs" onClick={e => handleRemoveSkill(e, 'hardskill', skillblock, key, profiletype._id)}></i> {skill}
	// 										</div>
	// 									))
	// 								:
	// 									<></>
	// 							}
	// 						</div>
	// 					))}
	// 				</Col>
	// 			</Row>,
	// 		selector: (profiletype) => profiletype.name,
	// 		sortable: true,
	// 	}
	// ]

    // const handleInputNewProfileTypes = ({target})=>{
    //     setNewSkills({
    //         ...newSkills,
    //         [target.name]: target.value
    //     })
    // }

    // const handleSelectTypeSoftskill = (optionselected) => {
    //     setTypeSoftskill(optionselected.target.value)
    // }

    // const handleSelectTypeHardskill = (optionselected) => {
    //     setTypeHardskill(optionselected.target.value)
    // }

    // const handleInputNewSkill = (typeskill)=>{
	// 	let newskill = document.getElementById("skill-"+typeskill).value
	// 	if(newskill !== ''){
	// 		document.getElementById("skill-"+typeskill).value = ""

	// 		let arrayNewSkills = newSkills[typeskill]
			
	// 		let blockskill
	// 		if(typeskill === 'softskills'){
	// 			blockskill = typeSoftskill
	// 		}else{
	// 			blockskill = typeHardskill
	// 		}

	// 		arrayNewSkills[blockskill].push(newskill)

	// 		setNewSkills({
	// 			...newSkills,
	// 			[typeskill]: {
	// 				...newSkills[typeskill],
	// 				[blockskill]: arrayNewSkills[blockskill]
	// 			}
	// 		})
	// 	}else{
	// 		Swal.fire({
	// 			showConfirmButton: true,
	// 			icon: 'warning',
	// 			text: t('admin.dashboard.setskill')
	// 		})
	// 	}
    // }

    // const handleOutputNewSkill = (typeskill, skillblock, idSkill)=>{
	// 	let arraySkills = newSkills[typeskill]
	// 	arraySkills[skillblock].splice(idSkill, 1)

	// 	setNewSkills({
	// 		...newSkills,
	// 		[typeskill]: {
	// 			...newSkills[typeskill],
	// 			[skillblock]: arraySkills[skillblock]
	// 		}
	// 	})
    // }

    // const handleAddProfileTypes = async(e) => {
    //     e.preventDefault()

	// 	if(newSkills.name !== undefined && newSkills.name !== ''){
	// 		dispatch(addProfileType(newSkills))
	// 		setNewSkills({
	// 			name: '',
	// 			softskills: {
	// 				interpersonal: [],
	// 				social: [],
	// 				methodical: [],
	// 				languages: [],
	// 				technological: []
	// 			},
	// 			hardskills: {
	// 				interpersonal: [],
	// 				social: [],
	// 				methodical: [],
	// 				languages: [],
	// 				technological: []
	// 			}
	// 		})
	// 	}else{
	// 		Swal.fire({
	// 			showConfirmButton: true,
	// 			icon: 'warning',
	// 			text: t('admin.dashboard.emptyname')
	// 		})
	// 	}
    // }

    // const handleRemoveSkill = (e, typeskill, blockskill, idSkill, idProfileType)=>{
    //     e.preventDefault()

    //     Swal.fire({
    //         showConfirmButton: true,
    //         showDenyButton: true,
    //         confirmButtonText: t('global.yes'),
    //         denyButtonText: t('global.no'),
    //         icon: 'question',
    //         text: t('admin.dashboard.areyousuredeleteskill')
    //     }).then((resultuser) => {
    //         if (resultuser.isConfirmed) {
	// 			dispatch(removeSkill(typeskill, blockskill, idSkill, idProfileType))
	// 			if(typeskill === 'softskill'){
	// 				setSkillaux(`softskill-`+blockskill+`-`+idSkill)
	// 			}else{
	// 				setSkillaux(`hardskill-`+blockskill+`-`+idSkill)
	// 			}
    //         }
    //     })
    // }

    useEffect(() => {
        if(resultprofileType){
            switch (resultprofileType) {
                case 'successaddprofiletype':
                    dispatch(getProfileTypes())
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.dashboard.successaddprofiletype')
                    })
                    break;
                case 'erroraddprofiletype':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('admin.dashboard.erroraddprofiletype')
                    })
                    break;
				case 'successremoveskill':
					document.getElementById(skillaux).remove()
					setSkillaux(null)
					Swal.fire({
						showConfirmButton: true,
						icon: 'success',
						text: t('admin.dashboard.successremoveskill')
					})
					break;
				case 'errorremoveskill':
					setSkillaux(null)
					Swal.fire({
						showConfirmButton: true,
						icon: 'warning',
						text: t('admin.dashboard.errorremoveskill')
					})
					break;
				case 'successremoveprofiletype':
					Swal.fire({
						showConfirmButton: true,
						icon: 'success',
						text: t('admin.dashboard.successremoveprofiletype')
					})
					break;
				case 'errorremoveprofiletype':
					Swal.fire({
						showConfirmButton: true,
						icon: 'warning',
						text: t('admin.dashboard.errorremoveprofiletype')
					})
					break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultprofileType])

	return (
		<>
			<Container className='cuerpo'>
				<Row>
					<h1>{t('admin.dashboard.welcome')}</h1>
					<p>{t('admin.dashboard.selectsection')}</p>
				</Row>
				<Row className="mt-2">
					<Col>
						<Card className='mb-5 sombra'>
                            <Card.Body className='px-5 pt-5'>
								{/* <Tabs defaultActiveKey="profiletypes" id="sections" className="mb-3 justify-content-between">
									<Tab eventKey="profiletypes" title={t('admin.dashboard.profiletypes')}>
										<Row className="text-center mt-4">
											<h1>{t('admin.dashboard.addNewProfileTypes')}</h1>
										</Row>
										<Row className="mt-1 mb-3">
											<Col>
												<Form.Control
													className="form-control-lg form-control-solid custom-form-control"
													type='text'
													name='name' 
													value={newSkills.name ||  ''}
													placeholder={t('admin.dashboard.nameprofiletype')}
													onChange={handleInputNewProfileTypes}
													required
												/>
											</Col>
										</Row>
										<Row className="text-center my-3">
											<Col xs={12} md={6} className="px-4">
												<Row className="my-3">
													<Col>
														<Row>
															<Col>
																<Form.Control
																	className="form-control-lg form-control-solid custom-form-control"
																	type='text'
																	id='skill-softskills'
																	name='skill-softskills'
																	placeholder={t('admin.dashboard.softskill')}
																/>
															</Col>
														</Row>
													</Col>
												</Row>
												<Row className="my-3">
													<Col>
														<select
															className="form-control mt-2"
															onChange={handleSelectTypeSoftskill}
															id="softskill_title_type"
															name="softskill_title_type"
															value={typeSoftskill}
														>
															{softskillBlocks?.map((skillblock, key) => (
																<option value={skillblock} key={key}>{t('admin.dashboard.'+skillblock)}</option>
															))}
														</select>
													</Col>
												</Row>
												<Row className="my-3">
													<Col>
														<Button id="addSkill" className="btn-secondary w-100" onClick={e => handleInputNewSkill('softskills')}>
															{t('admin.dashboard.addskill')}
														</Button>
													</Col>
												</Row>
												<Row className='my-3'>
													<Col>
														{softskillBlocks?.map((skillblock, index) => (
															<Fragment key={index}>
																{newSkills?.softskills?.[skillblock]?.length > 0
																	?
																		t('admin.dashboard.'+skillblock)
																	:
																		<></>
																}
																{newSkills?.softskills?.[skillblock]?.length > 0
																	?
																		newSkills?.softskills?.[skillblock]?.map((skill, key) => (
																			<div key={key} id={`skill-`+skillblock+`-`+key} className='text-start'>
																				<i className="fas fa-times fa-xs" onClick={e => handleOutputNewSkill('softskills', skillblock, key)}></i> {skill}
																			</div>
																		))
																	:
																		<></>
																}
															</Fragment>
														))}
													</Col>
												</Row>
											</Col>
											<Col xs={12} md={6} className="px-4">
												<Row className='my-3'>
													<Form.Control
														className="form-control-lg form-control-solid custom-form-control"
														type='text'
														id='skill-hardskills'
														name='skill-hardskills'
														placeholder={t('admin.dashboard.hardskills')}
													/>
												</Row>
												<Row className="my-3">
													<Col>
														<select
															className="form-control mt-2"
															onChange={handleSelectTypeHardskill}
															id="hardskill_title_type"
															name="hardskill_title_type"
															value={typeHardskill}
														>
															{hardskillBlocks?.map((skillblock, key) => (
																<option value={skillblock} key={key}>{t('admin.dashboard.'+skillblock)}</option>
															))}
														</select>
													</Col>
												</Row>
												<Row>
													<Button id="addSkill" className="btn-secondary w-100" onClick={e => handleInputNewSkill('hardskills')}>
														{t('admin.dashboard.addskill')}
													</Button>
												</Row>
												<Row className="my-3">
													<Col>
														{hardskillBlocks?.map((skillblock, index) => (
															<Fragment key={index}>
																{newSkills?.hardskills?.[skillblock]?.length > 0
																	?
																		t('admin.dashboard.'+skillblock)
																	:
																		<></>
																}
																{newSkills?.hardskills?.[skillblock]?.length > 0
																	?
																		newSkills?.hardskills?.[skillblock]?.map((skill, key) => (
																			<div key={key} id={`skill-`+skillblock+`-`+key} className='text-start'>
																				<i className="fas fa-times fa-xs" onClick={e => handleOutputNewSkill('hardskills', skillblock, key)}></i> {skill}
																			</div>
																		))
																	:
																		<></>
																}
															</Fragment>
														))}
													</Col>
												</Row>
											</Col>
										</Row>
										<Row className="text-center my-3">
											<Col>
												<Button type="submit" id="createProfileType" className="btn-primary w-100" onClick={handleAddProfileTypes}>
													{t('admin.dashboard.addNewProfileType')}
												</Button>
											</Col>
										</Row>
										<Row className="text-center mt-4">
											<h1>{t('admin.dashboard.profiletypes')}</h1>
										</Row>
										<Row className="my-3">
											<Col className="justify-content-center text-center">
												<Tabs defaultActiveKey="profileTypeslist" id="profileTypes" className="mb-3 justify-content-between">
													<Tab eventKey="profileTypeslist" title={t('admin.dashboard.profileTypeslist')}>
														<Row className="my-3 customtable-container">
															<Col className="justify-content-center text-center">
																{profileTypes?.length > 0
																	?
																		<CustomDataTable columns={columnsProfileTypes} data={profileTypes} />
																	:
																		<>{t('admin.dashboard.thereisnotprofileTypes')}</>
																}
															</Col>
														</Row>
													</Tab>
												</Tabs>
											</Col>
										</Row>
									</Tab>
									<Tab eventKey="candidates" title={t('admin.dashboard.candidates')}>
										<Row className="text-center mt-4">
											<h1>{t('admin.dashboard.candidates')}</h1>
										</Row>
										<Row className="my-3">
											<Col className="justify-content-center text-center">
												<Tabs defaultActiveKey="candidateslist" id="candidates" className="mb-3 justify-content-between">
													<Tab eventKey="candidateslist" title={t('admin.dashboard.candidateslist')}>
														<Row className="my-3 customtable-container">
															<Col className="justify-content-center text-center">
																{candidates?.length > 0
																	?
																		<CustomDataTable columns={columnsCandidates} data={candidates} />
																	:
																		<>{t('admin.dashboard.thereisnotcandidates')}</>
																}
															</Col>
														</Row>
													</Tab>
												</Tabs>
											</Col>
										</Row>
									</Tab>
									<Tab eventKey="schools" title={t('admin.dashboard.schools')}>
										<Row className="text-center mt-4">
											<h1>{t('admin.dashboard.schools')}</h1>
										</Row>
										<Row className="my-3">
											<Col className="justify-content-center text-center">
												<Tabs defaultActiveKey="schoolslist" id="schools" className="mb-3 justify-content-between">
													<Tab eventKey="schoolslist" title={t('admin.dashboard.schoolslist')}>
														<Row className="my-3 customtable-container">
															<Col className="justify-content-center text-center">
																{schools?.length > 0
																	?
																		<CustomDataTable columns={columnsSchools} data={schools} />
																	:
																		<>{t('admin.dashboard.thereisnotschools')}</>
																}
															</Col>
														</Row>
													</Tab>
												</Tabs>
											</Col>
										</Row>
									</Tab>
								</Tabs> */}
							</Card.Body>
						</Card>
					</Col>
				</Row>
			</Container>
		</>
	)
}